import React from "react";

import "./ErrorPrompt.css";

export const ErrorPrompt = () => {
  return <h3 className="errorPrompt">An error occured</h3>;
};
